import React, {useEffect, useRef, useState} from "react";
import "./golfstatus-tms.scss";
import {connect, useSelector} from "react-redux";
import {
  GSAppLayout,
  GSAppNavigationHeader,
  GSListPage,
  GSInput,
  GSCircleImage,
  GSPageBanner,
  GSItemInfo,
} from "golfstatus_react_components";
import logo from "../images/GSLogo.svg";
import {
  setNav,
  selectUser,
  clearNotifications,
  setHistory,
  addPathToHistory,
  removeNotification,
  getCurrentAnnouncements,
  selectAnnouncements,
  setNotifications,
} from "../reducers/appSlice";
import { useNavigate, useLocation, Routes, Route } from "react-router-dom";

import {faScrewdriverWrench, faSearch, faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import { getCurrentUser } from "../app/gs-session";
import TMSDashboard from "./dashboard/tms-dashboard";
import TmsDashboard from "./dashboard/tms-dashboard";
import TmsGettingStarted from "./dashboard/tms-getting-started";
import TournamentDetail from "./tournament/tournament-details";
import TournamentOverview from "./tournament/tournament-overview/tournament-overview";

import {
  getOrganizationList,
} from "../reducers/organizationSlice";
import { useNotificationBanner } from "../hooks/notificationHooks";
import { getTournamentRoutes } from "../routes/tournaments";
import { getTournamentRoundRoutes } from "../routes/tournament/rounds";
import { getTournamentTeamsRoutes } from "../routes/tournament/teams";
import { getSettingsRoutes } from "../routes/tournament/settings";
import { getTournamentSponsorsRoutes } from "../routes/tournament/sponsors";
import { getTournamentPromotionRoutes } from "../routes/tournament/promotion";
import { getTournamentFlightingRoutes } from "../routes/tournament/flighting";
import { getTournamentLeaderboardRoutes } from "../routes/tournament/leaderboards";
import { getTournamentPrintoutRoutes } from "../routes/tournament/printouts";
import { getReportingRoutes } from "../routes/tournament/reporting";
import { getTournamentMessagesRoutes } from "../routes/tournament/messages";
import { saveTournament } from "../reducers/tournamentSlice";

const GolfstatusTMS = (props) => {
  const { nav, appNotifications, dispatch, currentTournament } = props;
  const routeNavigate = useNavigate();
  const { pathname } = useLocation();
  const [hideEnvironment, setHideEnvironment] = useState(false);
  const announcements = useSelector(selectAnnouncements);

  useEffect(() => {
    const nav = [
      {
        id: 1,
        label: "Tournaments Overview",
        url: "/",
        isSelectable: true,
      },
      {
        id: 2,
        label: "My Tournaments",
        url: "/tournaments",
        isSelectable: true,
      },
      {
        id: 3,
        label: "Revenue Enhancements",
        url: `${process.env.REACT_APP_GOLFSTATUS_EVENTS_BASE_URL}/event/revenue-enhancements/register`,
        isExternal: true,
        isSelectable: true,
      },
      {
        id: 4,
        label: "Knowledge Base",
        url: "https://golfstatus.stonly.com/kb/en",
        isExternal: true,
        isSelectable: true,
      },
    ];
    if (!pathname.includes(currentTournament?.id)) {
      dispatch(setNav(nav));
      dispatch(setHistory([]));
    } else {
      dispatch(addPathToHistory(pathname));
    }
  }, [dispatch, pathname, currentTournament?.id]);

  //refreshed as the user moves around so permission changes, like a new
  //tournament or manager, are picked up. it stays out of the effect above so
  //the tournament finishing loading doesn't fetch them a second time.
  useEffect(() => {
    dispatch(selectUser(getCurrentUser()?.uid));
    dispatch(getCurrentAnnouncements());
  }, [dispatch, pathname]);

  const announcementRef = useRef([]);
  const notificationRef = useRef([]);
  announcementRef.current = announcements;
  notificationRef.current = appNotifications;

  const totalAnnouncements = announcements.length;

  useEffect(() => {
    const notifications = announcementRef.current.map?.((announcement) => ({
      id: announcement.id,
      type: "announcement",
      header: (
        <GSItemInfo
          header={announcement.header}
          value={announcement.description}
          icon={faScrewdriverWrench}
        />
      ),
    })) ?? [];
    dispatch(setNotifications([...notificationRef.current.filter?.(n => n.type !== "announcement"), ...notifications]));
  }, [dispatch, totalAnnouncements]);

  useEffect(() => {
    const user = getCurrentUser();
    if (user?.uid) {
      dispatch(getOrganizationList({ userID: user?.uid }));
    }
  }, [dispatch]);

  const getListPage = (title) => {
    if (title === "Dashboard") {
      return <TMSDashboard />;
    }
    const page = { title: title, getDefaultSearch: getDefaultSearch };
    return <GSListPage {...page} />;
  };

  const getActiveRoute = () => {
    return `${pathname}`;
  };

  const getTitle = () => {
    return (
      <GSAppNavigationHeader
        logo={logo}
        title="Tournament Management"
      ></GSAppNavigationHeader>
    );
  };

  const getFooter = () => {
    const user = getCurrentUser();
    const defaultAvatar = "https://api.golfstatus.dev/images/user_round.png";
    return [
      // {
      //   id: 5,
      //   label: "Documentation",
      //   url: "documentation",
      //   isSelectable: true,
      // },
      {
        id: 0,
        label: (
          <GSCircleImage
            url={user?.avatar ? user.avatar : defaultAvatar}
            size="large"
          ></GSCircleImage>
        ),
        isSelectable: true,
        url: `${process.env.REACT_APP_GOLFSTATUS_PROFILE_URL}`,
        isExternal: true,
      },
    ];
  };

  const navigate = (item) => {
    if (item.isExternal) {
      window.open(item?.url);
    } else {
      if (item?.url) {
        routeNavigate(item?.url);
      }
    }
  };

  const getEnvironmentActions = () => {
    return [
      {
        actionIcon: faTimesCircle,
        type: "navigation",
        size: "secondary",
        actionClick: hideNavEnvironment,
      },
    ];
  };

  const getShowEnvironment = () => {
    if (hideEnvironment) {
      return false;
    }
    return (
      process.env.REACT_APP_ENV !== "production" &&
      process.env.REACT_APP_ENV !== "demo"
    );
  };

  const hideNavEnvironment = () => {
    setHideEnvironment(true);
  };

  const getNav = () => {
    return {
      navItems: nav,
      title: getTitle(),
      footerItems: getFooter(),
      itemSelected: navigate,
      activeRoute: getActiveRoute(),
      showEnv: getShowEnvironment(),
      environmentActions: getEnvironmentActions(),
      environment: `${process.env.REACT_APP_ENV} environment`,
      environmentDescription: process.env.REACT_APP_GOLFSTATUS_BASE_API_URL,
    };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getNavigationActions = () => {
    return [
      {
        title: "Clear",
        size: "secondary",
        onClick: timeoutAction,
      },
    ];
  };

  const getDefaultSearch = () => {
    return <GSInput leftIcon={faSearch} rightIcon={faTimesCircle}></GSInput>;
  };

  const getRouter = () => {
    return (
      <Routes>
        <Route path={"/"} element={<TmsDashboard />} />
        {getTournamentRoutes()}
        <Route path={"/documentation"} element={getListPage("Documentation")} />
        <Route path={"/copy/:id"} element={<TmsGettingStarted />} />
        <Route path={"/:id"} element={<TournamentDetail />}>
          <Route index element={<TournamentOverview />} />
          {getTournamentRoundRoutes()}
          {getTournamentTeamsRoutes()}
          {getSettingsRoutes()}
          {getTournamentSponsorsRoutes()}
          {getTournamentPromotionRoutes()}
          {getTournamentFlightingRoutes()}
          {getTournamentLeaderboardRoutes()}
          {getTournamentPrintoutRoutes()}
          {getReportingRoutes()}
          {getTournamentMessagesRoutes()}
        </Route>
      </Routes>
    );
  };

  const goToInvoiceSetup = (notification) => {
    routeNavigate(`./${notification?.id}/settings/payments/invoice`)
  }

  const hideInvoicingNotification = () => {
    dispatch(saveTournament({...currentTournament, invoicingBannerActive: false}));
  }

  const invoiceActions = (notification) => [
    {
      title: "Invoice Setup",
      actionClick: () => {
        goToInvoiceSetup(notification)
      },
      type: "black",
    },
    {
      actionIcon: faTimesCircle,
      actionClick: () => {
        dispatch(removeNotification(notification));
        hideInvoicingNotification();
      },
      type: "secondary transparent",
    }
  ]

  const copyWarnings = (notification) => [
    {
      title: "View",
      actionClick: () => {
        routeNavigate(notification.fixUrl);
      },
      type: "secondary orange",
    },
    {
      title: "Clear",
      actionClick: () => {
        dispatch(clearNotifications());
      },
      type: "secondary",
    },
  ];

  const announcementActions = (notification) => [
    {
      actionIcon: faTimesCircle,
      actionClick: () => {
        dispatch(removeNotification(notification));
      },
      type: "secondary transparent",
    }
  ]

  const defaultActions = [
    {
      title: "Clear",
      actionClick: () => {
        dispatch(clearNotifications());
      },
      type: "secondary",
    },
  ];

  const getBannerActions = (notification) => {
    if (notification?.fixUrl) {
      return copyWarnings(notification);
    }
    if (notification?.type === "invoice") {
      return invoiceActions(notification);
    }
    if (notification?.type === "announcement") {
      return announcementActions(notification);
    }
    return defaultActions;
  }

  const [bannerNotifications] = useNotificationBanner({
    notifications: appNotifications.map?.((notification) => ({
      ...notification,
      bannerActions: getBannerActions(notification)
    })),
    navigationActions: getNavigationActions(),
    timeoutAction,
  });

  return (
    <golfstatus-tms>
      <GSAppLayout
        nav={getNav()}
        navigationItemSelected={navigate}
        notification={
          appNotifications?.length > 0 ? (
            <GSPageBanner {...bannerNotifications} />
          ) : (
            false
          )
        }
        routes={getRouter()}
      ></GSAppLayout>
    </golfstatus-tms>
  );
};

const mapStateToProps = (state) => ({
  nav: state.app.nav,
  appNotifications: state.app.notifications,
  currentTournament: state.tournaments.currentTournament,
});

export default connect(mapStateToProps)(GolfstatusTMS);
